import { Outlet } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'

export function RootLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <main className="flex-1">
        <Outlet />
      </main>
      <Toaster position="top-center" />
    </div>
  )
}

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <div className="container mx-auto px-4 py-8 flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
      <Toaster position="top-center" />
    </div>
  )
}